<template>
  <div class="w-full h-full">
    <div class="grid grid-cols-1 gap-4 h-full w-full" :class="getDevicePixel >= LAPTOP ? 'grid-cols-2' : ''">
      <div class="h-full col-span-1 template-list">
        <el-card class="box-card h-full border-none" style="width: 100%; position: relative;">
          <div slot="header" class="batch-list flex justify-between items-center mb-5">
            <span class="whitespace-nowrap font-bold leading-5 text-sm">利用するテンプレートを選んでください</span>
            <div class="flex justify-end w-full">
                <el-input v-model="inputSearchTemplate" @keyup.native="keyUpSearchTemplate" class="ocr-search-input w-3/4 search-batch-list mr-3 sm:mr-6">
                  <template #append>
                    <span @click="searchBatch" class="cursor-pointer">
                      <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.75794 14.5152C11.4902 14.5152 14.5159 11.4897 14.5159 7.7576C14.5159 4.02548 11.4902 1 7.75794 1C4.02563 1 1 4.02548 1 7.7576C1 11.4897 4.02563 14.5152 7.75794 14.5152Z" stroke="#141414" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.7338 12.918L16.9999 17.0013" stroke="#141414" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                  </template>
                </el-input>
              </div>
          </div>

          <el-dialog :show-close="false" :visible.sync="showAddTemplateModal"
                     title="テンプレートの作成" :width="getDevice == 'desktop' ? '30%' : '95%'"
                     class="modal-add ocr-dialog" @closed="resetFormAddTemplate"
                     :close-on-press-escape="false"
                     :close-on-click-modal="false"
          >
            <ValidationObserver ref="formAddTemplate" >
                <el-form ref="refAddTemplate" @keyup.enter.prevent @submit.native.prevent="createNewTemplate">
                  <ValidationProvider
                    name="新しい書類画像のファイルを選んでください。"
                    :rules="{
                      required: true,
                    }"
                    v-slot="{ errors }"
                    classcustom-class=""
                    ref="processTemplate"
                  >
                      <p class="mb-4 text-red-500">{{ errorCreateTemplate }}</p>
                      <p class="title-modal-add">新しい書類画像のファイルを選んでください。(jpg, png, pdf)</p>
                      <div class="flex justify-between flex-wrap items-center">
                        <el-button @click="selectFileTemplate" class="w-auto ocr-button ocr-button-default">ファイルを選択</el-button>
                        <input type="file" @change="chooseFileTemplate" ref="selectFileTemplate" class="hidden"/>
                        <div class="w-1/2"><el-checkbox class="ocr-checkbox" v-model="addNewTemplate.is_preprocess" label="撮影の画像である"></el-checkbox></div>
                      </div>
                      <div class="text-gray-400">{{ file_name }}</div>
                      <div class="mt-4"><span class="text-red-500">{{ errors[0] }}</span></div>
                  </ValidationProvider>
                      <p class="title-modal-add">テンプレート名</p>
                  <ValidationProvider
                    name="テンプレート名"
                    :rules="{
                      required: true,
                    }"
                    v-slot="{ errors }"
                    class=""
                    ref="nameTemplate"
                  >
                      <el-input class="ocr-input" placeholder="テンプレート名" :maxlength="100" v-model="addNewTemplate.name"></el-input>
                      <div class="mt-4" v-if="showAddTemplateModal"><span class="text-red-500">{{ errors[0] }}</span></div>
                  </ValidationProvider>
              </el-form>
            </ValidationObserver>
            <template #footer>
                <span class="dialog-footer">
                  <el-button @click="resetFormAddTemplate" class="ocr-button ocr-button-default">
                    いいえ
                  </el-button>
                  <el-button class="btn-main ocr-button ocr-button-default" @click="createNewTemplate" :disabled="disableCreate || !addNewTemplate.name || !file_name">作成</el-button>
                </span>
              </template>
          </el-dialog>

          <div class="cover-template mb-6 md:mb-0">
            <div v-if="templates.static && templates.static.length" class="bg-red-200 border-solid border-4 border-light-blue-500">
              <div v-for="template in templates.static"
                :key="template.id"
                :class="{'bg-yellow-active': templateActive.id === template.id}"
                @click="selectTemplate(template)"
                class="custom-td-table w-full border-b border-gray-200 cursor-pointer p-3 bg-yellow"
              >
              {{ template.name }}
              </div>
            </div>
            <div v-if="isCheckALlTemplate" class="cursor-pointer template-grid-item">
              <div class="template-grid-item-grid bg-yellow flex justify-between">
                <div class="template-grid-item-content add-template-button bg-fa" @click="openModalAddTemplate">
                  <div class="el-icon-plus"></div>
                </div>
              </div>
            </div>
            <div v-for="template in templates.dynamic"
              :key="template.id"
              @click="selectTemplate(template)"
              class="cursor-pointer template-grid-item"
            >
              <div class="template-grid-item-grid bg-yellow bg-fa" :class="{'bg-yellow-active': templateActive.id === template.id}">
                <div class="template-grid-item-content">
                  <img :src="`${backendUrl}/${template.url}`" alt="">
                  <el-popover
                    :placement="getDevice == 'desktop' ? 'bottom-end' : 'bottom-start'"
                    min-width="130"
                    trigger="click"
                    @after-enter="showTemplateMenu(template.id)"
                    @hide="showTemplateMenu"
                    popper-class="bg-transparent shadow-none border-none"
                  >
                    <div class="flex flex-wrap custom-popover">
                      <el-button type="text" @click="goToTemplateDetail(template.id, collectionActive.id)" class="w-full btn-rename-batch ocr-dropdown-item">テンプレートを編集する</el-button>
                      <div class="ocr-hr hr-90"></div>
                      <el-button type="text" v-if="isCheckALlTemplate" @click="openUpdateTemplateModal(template)" class="w-full btn-rename-batch ocr-dropdown-item">テンプレート名を編集する</el-button>
                      <div class="ocr-hr hr-90"></div>
                      <el-button type="text" v-if="isCheckALlTemplate" @click="confirmDelete = true" class="w-full btn-rename-batch ocr-dropdown-item">テンプレートを削除する</el-button>
                      <el-button
                        v-if="template.is_assignment == true"
                        type="text"
                        @click="goToTemplateAssignment(template.id)"
                        class="w-full btn-rename-batch"
                      >
                        正解答を追加する
                      </el-button>
                    </div>
                    <el-button type="text" slot="reference" style="margin-left: 0px; color: black; padding: 0px 0px; border: unset;" class="template-grid-item-menu">
                      <span v-if="isTemplateMenuShow === template.id"><i class="el-icon-close custom-icon-close"></i></span>
                      <span v-else>
                        <img class="el-icon-setting custom-icon-close" src="@/assets/setting-icon.png" alt="">
                      </span>
                    </el-button>
                  </el-popover>
                  </div>
              </div>
              <div class="template-grid-item-name">{{ template.name }}</div>
            </div>
          </div>
          <!-- PAGINATE -->
          <div
            :class="templates.dynamic.length != 0 ? 'block' : 'hidden'"
            class="bg-white lg:absolute bottom-0 w-full z-20"
          >
            <el-pagination
              class="text-center mt-4 ocr-pagination"
              background
              @current-change="handleCurrentChangeTemplate"
              :current-page.sync="paginateTemplate.currentPage"
              :page-size="isCheckALlTemplate ? paginateTemplate.page_size : 12"
              :pager-count="getDevice == 'desktop' ? 7 : 5"
              layout="prev, pager, next"
              :total="paginateTemplate.totalItem"
            >
            </el-pagination>
          </div>
        </el-card>
      </div>

      <el-dialog
        title=""
        :visible.sync="confirmDelete"
        :show-close="false"
        :width="getDevice == 'desktop' ? '30%' : '95%'"
      >
        <span>指定しているテンプレートを本当に削除したいですか？</span>
        <span slot="footer" class="dialog-footer">
        <el-button class="ocr-button ocr-button-default" @click="confirmDelete = false">いいえ</el-button>
        <el-button type="primary" class="btn-main ocr-button" @click="doDeleteTemplate()">はい、削除する</el-button>
        </span>
      </el-dialog>

      <div class="h-full col-span-1 batch-list" ref="batch-list-ref">
        <el-card class="box-card h-full border-none" style="width: 100%; position: relative;">
          <div class="box-header" slot="header" >
            <div class="uploader">
              <Uploader
                ref="ocr-uploader"
                @on-file-added="chooseFileBatchUpload"
                @on-files-added="onFilesAdded"
              />
            </div>
            <div class="flex justify-between items-end mb-5 mt-6">
              <span class="whitespace-nowrap list-title batch-title">これまで読取処理</span>
              <div class="flex justify-end w-full">
                <el-input v-model="inputSearchBatch" @keyup.native="keyUpSearchBatch" class="ocr-search-input w-5/6">
                  <template #append>
                    <span @click="searchBatch" class="cursor-pointer">
                      <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.75794 14.5152C11.4902 14.5152 14.5159 11.4897 14.5159 7.7576C14.5159 4.02548 11.4902 1 7.75794 1C4.02563 1 1 4.02548 1 7.7576C1 11.4897 4.02563 14.5152 7.75794 14.5152Z" stroke="#141414" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.7338 12.918L16.9999 17.0013" stroke="#141414" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                  </template>
                </el-input>
              </div>
            </div>
          </div>

          <el-table
            ref="batch-list-table"
            :data="batchListFormat"
            highlight-current-row
            @current-change="handleChangeBatch($event, false)"
            @row-click="selectBatch"
            empty-text="データ無し"
            :style="`width: 100%;`"
            v-if="batchListFormat && getDevicePixel >= LAPTOP"
            class="custom-el-table ocr-table"
          >
            <el-table-column property="created" label="最終更新" class-name="custom-name-tbl-batch" width="150px">
              <template slot-scope="scope">
                <div class="whitespace-nowrap">{{ $moment(scope.row.modified).format('YYYY/MM/DD HH:mm') }}</div>
              </template>
            </el-table-column>
            <el-table-column property="name" label="処理名" class-name="custom-name-tbl-batch" min-width="150px">
              <template slot-scope="scope">
                <router-link :to="{ name: 'confirm_result', params: { template_id: templateActive.id, template_batch_id: scope.row.id }}" class="ocr-template-name ocr-text-truncate decoration"><span>{{ scope.row.name }}</span></router-link>

              </template>
            </el-table-column>
            <el-table-column label="読取完了" class-name="custom-name-tbl-batch" min-width="130px">
              <template slot-scope="scope">
                <div class="w-full">
                  <div class="flex justify-between items-center table-status-column">
                    <el-progress :text-inside="true" :show-text="false" :stroke-width="12" :percentage="calcProcessed(scope.row.n_files, scope.row.n_processed)" status="warning" class="w-20 ocr-progress-success ocr-progress column-progress"></el-progress>
                      <div class="column-processed">
                        <el-button type="text" size="medium" class="p-0 text-center" v-if="calcProcessRunning(scope.row.status)">
                          <i class="el-icon-loading process-icon"></i>
                        </el-button>
                        <el-button type="text" size="medium" class="p-0 text-center" v-if="calcProcessFailed(scope.row.status)">
                          <i class="el-icon-circle-close process-icon red-icon"></i>
                        </el-button>
                        <el-button type="text" size="medium" class="p-0 text-center ocr-icon" v-else-if="calcProcessImage(scope.row.status) && calcProcessed(scope.row.n_files, scope.row.n_processed) === 100">
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.99998 18C7.21995 18 5.47989 17.4722 3.99985 16.4832C2.51981 15.4943 1.36626 14.0887 0.685077 12.4442C0.00388972 10.7997 -0.174327 8.99004 0.17294 7.24421C0.520206 5.49838 1.37737 3.89474 2.63604 2.63606C3.89471 1.37739 5.49835 0.520192 7.24418 0.172925C8.99001 -0.174342 10.7996 0.00393278 12.4441 0.685122C14.0887 1.36631 15.4943 2.51983 16.4832 3.99987C17.4721 5.47992 18 7.22001 18 9.00004C17.9975 11.3862 17.0485 13.6739 15.3612 15.3612C13.6739 17.0485 11.3862 17.9975 8.99998 18V18ZM8.99998 1.51667C7.51991 1.51667 6.07307 1.95553 4.84244 2.77782C3.61181 3.6001 2.65266 4.76883 2.08626 6.13624C1.51987 7.50365 1.37168 9.00832 1.66043 10.46C1.94918 11.9116 2.66189 13.245 3.70846 14.2915C4.75503 15.3381 6.08844 16.0508 7.54007 16.3396C8.9917 16.6283 10.4963 16.4801 11.8637 15.9137C13.2311 15.3473 14.3999 14.3882 15.2222 13.1575C16.0444 11.9269 16.4834 10.4801 16.4834 9.00004C16.4811 7.01602 15.6919 5.11389 14.289 3.71098C12.8861 2.30806 10.984 1.51893 8.99998 1.51667V1.51667Z" fill="#FFCC33"/>
                            <path d="M7.79793 13.1184C7.67342 13.1184 7.55014 13.0938 7.43517 13.046C7.32019 12.9983 7.21578 12.9282 7.12797 12.84L3.81819 9.53015C3.65968 9.34868 3.57604 9.11382 3.58416 8.87301C3.59228 8.6322 3.69158 8.40347 3.86195 8.2331C4.03232 8.06272 4.26105 7.9634 4.50186 7.95528C4.74267 7.94715 4.97756 8.0308 5.15903 8.18931L7.79793 10.8292L12.6224 6.00468C12.8041 5.8477 13.0385 5.76529 13.2785 5.77407C13.5184 5.78286 13.7461 5.88216 13.9159 6.05201C14.0856 6.22186 14.1847 6.44964 14.1933 6.6896C14.2019 6.92956 14.1194 7.16388 13.9623 7.34546L8.46881 12.84C8.29087 13.018 8.0496 13.1181 7.79793 13.1184Z" fill="#FFCC33"/>
                          </svg>
                        </el-button>
                      </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="person" label="チェック済" width="120px">
              <template slot-scope="scope">
                <div class="flex justify-between items-center table-status-column">
                  <div>{{ scope.row.n_confirmed }}/{{ scope.row.n_files }}
                  </div>
                  <el-button type="text" size="medium" class="p-0 text-center ocr-icon orc-status-column" v-if="calcConfirmed(scope.row.n_confirmed, scope.row.n_results) >= 100">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.99998 18C7.21995 18 5.47989 17.4722 3.99985 16.4832C2.51981 15.4943 1.36626 14.0887 0.685077 12.4442C0.00388972 10.7997 -0.174327 8.99004 0.17294 7.24421C0.520206 5.49838 1.37737 3.89474 2.63604 2.63606C3.89471 1.37739 5.49835 0.520192 7.24418 0.172925C8.99001 -0.174342 10.7996 0.00393278 12.4441 0.685122C14.0887 1.36631 15.4943 2.51983 16.4832 3.99987C17.4721 5.47992 18 7.22001 18 9.00004C17.9975 11.3862 17.0485 13.6739 15.3612 15.3612C13.6739 17.0485 11.3862 17.9975 8.99998 18V18ZM8.99998 1.51667C7.51991 1.51667 6.07307 1.95553 4.84244 2.77782C3.61181 3.6001 2.65266 4.76883 2.08626 6.13624C1.51987 7.50365 1.37168 9.00832 1.66043 10.46C1.94918 11.9116 2.66189 13.245 3.70846 14.2915C4.75503 15.3381 6.08844 16.0508 7.54007 16.3396C8.9917 16.6283 10.4963 16.4801 11.8637 15.9137C13.2311 15.3473 14.3999 14.3882 15.2222 13.1575C16.0444 11.9269 16.4834 10.4801 16.4834 9.00004C16.4811 7.01602 15.6919 5.11389 14.289 3.71098C12.8861 2.30806 10.984 1.51893 8.99998 1.51667V1.51667Z" fill="#FFCC33"/>
                      <path d="M7.79793 13.1184C7.67342 13.1184 7.55014 13.0938 7.43517 13.046C7.32019 12.9983 7.21578 12.9282 7.12797 12.84L3.81819 9.53015C3.65968 9.34868 3.57604 9.11382 3.58416 8.87301C3.59228 8.6322 3.69158 8.40347 3.86195 8.2331C4.03232 8.06272 4.26105 7.9634 4.50186 7.95528C4.74267 7.94715 4.97756 8.0308 5.15903 8.18931L7.79793 10.8292L12.6224 6.00468C12.8041 5.8477 13.0385 5.76529 13.2785 5.77407C13.5184 5.78286 13.7461 5.88216 13.9159 6.05201C14.0856 6.22186 14.1847 6.44964 14.1933 6.6896C14.2019 6.92956 14.1194 7.16388 13.9623 7.34546L8.46881 12.84C8.29087 13.018 8.0496 13.1181 7.79793 13.1184Z" fill="#FFCC33"/>
                    </svg>
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="person" label="" width="140px">
              <template slot-scope="scope">
                <div class="text-right table-status-column">
                  <el-button size="mini" class="ocr-button custom-btn-add column-export-csv" @click="down_csv(scope.row)" :disabled="!calcProcessImage(scope.row.status)">
                    CSV ダウンロード
                  </el-button>
                  <div style="display: none">
                    <download-csv :data="items_data" :name="`${CSVNameDownload || 'ocr_result'}.csv`" :testing="true" @export-finished="checkFinish">
                      <el-button class="width-btn ocr-button custom-btn-add column-export-csv" :ref="`download_csv_detail_${scope.row.id}`" type="success" size="mini">CSV ダウンロード</el-button>
                    </download-csv>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="" width="50px" align="center" class-name="popover-table">
              <template slot-scope="scope">
                <el-popover
                  :placement="getDevice == 'desktop' ? 'bottom-end' : 'bottom-start'"
                  min-width="130"
                  trigger="click"
                  @after-enter="showPopOver(scope.row.id)"
                  @hide="hidePopOver"
                  popper-class="bg-transparent shadow-none border-none"
                >
                  <div class="flex flex-wrap custom-popover">
                    <el-button type="text" @click="openUpdateBatchModal(scope.row)" class="w-full btn-rename-batch ocr-dropdown-item">処理名変更</el-button>
                    <div class="ocr-hr hr-90"></div>
                    <el-button type="text" size="medium" class="w-full btn-rename-batch ocr-dropdown-item" @click="reRunOCR(scope.row)">
                      再読取
                    </el-button>
                    <div class="ocr-hr hr-90"></div>
                    <el-button type="text" @click="confirmDeleteBatch = true" class="w-full btn-rename-batch ocr-dropdown-item">削除</el-button>
                  </div>
                  <el-button @click="openOptionBatch(scope.row)" type="text" slot="reference" style="margin-left: 0px; color: black; padding: 0px 0px; border: unset;">
                    <svg width="30" height="15" viewBox="0 0 3 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.25865 1.76723C2.25865 2.02886 2.16694 2.25138 1.98352 2.4348C1.80152 2.6168 1.58113 2.7078 1.32234 2.7078C1.06072 2.7078 0.838195 2.6168 0.654773 2.4348C0.471352 2.25138 0.379641 2.02886 0.379641 1.76723C0.379641 1.50419 0.472773 1.28237 0.659039 1.1018C0.845305 0.919797 1.06498 0.828797 1.31808 0.828797C1.57828 0.828797 1.80009 0.921219 1.98352 1.10606C2.16694 1.29091 2.25865 1.5113 2.25865 1.76723ZM2.25865 7.76723C2.25865 8.02886 2.16694 8.25138 1.98352 8.4348C1.80152 8.6168 1.58113 8.7078 1.32234 8.7078C1.06072 8.7078 0.838195 8.6168 0.654773 8.4348C0.471352 8.25138 0.379641 8.02886 0.379641 7.76723C0.379641 7.50419 0.472773 7.28237 0.659039 7.1018C0.845305 6.9198 1.06498 6.8288 1.31808 6.8288C1.57828 6.8288 1.80009 6.92122 1.98352 7.10606C2.16694 7.29091 2.25865 7.5113 2.25865 7.76723ZM2.25865 13.7672C2.25865 14.0289 2.16694 14.2514 1.98352 14.4348C1.80152 14.6168 1.58113 14.7078 1.32234 14.7078C1.06072 14.7078 0.838195 14.6168 0.654773 14.4348C0.471352 14.2514 0.379641 14.0289 0.379641 13.7672C0.379641 13.5042 0.472773 13.2824 0.659039 13.1018C0.845305 12.9198 1.06498 12.8288 1.31808 12.8288C1.57828 12.8288 1.80009 12.9212 1.98352 13.1061C2.16694 13.2909 2.25865 13.5113 2.25865 13.7672Z" fill="#141414"/>
                    </svg>
                  </el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>

          <!-- Batch List Mobile -->
          <div v-else class="table-mobile">
            <div v-if="batchListFormat.length">
              <div v-for="batch in batchListFormat" :key="batch.id" @click="activeBatchMobile(batch)" :class="activeBatchMobileId == batch.id ? 'current-row-mobile': ''">
                <div class="items-center flex justify-between date-time bg-defaul-batch">
                  <div class="title">
                    <div class="whitespace-nowrap font-light">
                      <span class="md:mr-3 mr-2">{{ $moment(batch.modified).format('YYYY/MM/DD') }}</span>
                      <span>{{ $moment(batch.modified).format('HH:mm') }}</span>
                    </div>
                  </div>
                  <div class="btn items-center flex">
                    <el-button size="mini" class="ocr-button custom-btn-add column-export-csv" @click="down_csv(batch, true)" :disabled="!calcProcessImage(batch.status)">
                      CSV ダウンロード
                    </el-button>
                    <div style="display: none">
                      <download-csv :data="items_data" :name="`${CSVNameDownload || 'ocr_result'}.csv`" :testing="true" @export-finished="checkFinish">
                        <el-button class="width-btn ocr-button custom-btn-add column-export-csv" :ref="`download_csv_detail_${batch.id}`" type="success" size="mini" :disabled="!calcProcessImage(batch.status)">CSV ダウンロード</el-button>
                      </download-csv>
                    </div>
                    <div class="popover-block text-right">
                    <el-popover
                      :placement="getDevice == 'desktop' ? 'bottom-end' : 'bottom-start'"
                      min-width="130"
                      trigger="click"
                      popper-class="bg-transparent shadow-none border-none ocr-dropdown"
                      @after-enter="showPopOver(batch.id)"
                      @hide="hidePopOver"
                    >
                      <div class="flex flex-wrap custom-popover custom-popover-list ocr-dropdown-list">
                        <el-button type="text" @click="openUpdateBatchModal(batch)" class="w-full btn-rename-batch ocr-dropdown-item">処理名変更</el-button>
                        <div class="ocr-hr hr-90"></div>
                        <el-button type="text" class="w-full btn-rename-batch ocr-dropdown-item" @click="reRunOCR(batch)" :disabled="!calcProcessImage(batch.status)">
                          再読取
                        </el-button>
                        <div class="ocr-hr hr-90"></div>
                        <el-button type="text" @click="confirmDeleteBatch = true" class="w-full btn-rename-batch ocr-dropdown-item">削除</el-button>
                      </div>
                      <el-button @click="openOptionBatch(batch)" type="text" slot="reference" style="margin-left: 0px; color: black; padding: 0px 0px; border: unset;">
                        <svg width="30" height="15" viewBox="0 0 3 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25865 1.76723C2.25865 2.02886 2.16694 2.25138 1.98352 2.4348C1.80152 2.6168 1.58113 2.7078 1.32234 2.7078C1.06072 2.7078 0.838195 2.6168 0.654773 2.4348C0.471352 2.25138 0.379641 2.02886 0.379641 1.76723C0.379641 1.50419 0.472773 1.28237 0.659039 1.1018C0.845305 0.919797 1.06498 0.828797 1.31808 0.828797C1.57828 0.828797 1.80009 0.921219 1.98352 1.10606C2.16694 1.29091 2.25865 1.5113 2.25865 1.76723ZM2.25865 7.76723C2.25865 8.02886 2.16694 8.25138 1.98352 8.4348C1.80152 8.6168 1.58113 8.7078 1.32234 8.7078C1.06072 8.7078 0.838195 8.6168 0.654773 8.4348C0.471352 8.25138 0.379641 8.02886 0.379641 7.76723C0.379641 7.50419 0.472773 7.28237 0.659039 7.1018C0.845305 6.9198 1.06498 6.8288 1.31808 6.8288C1.57828 6.8288 1.80009 6.92122 1.98352 7.10606C2.16694 7.29091 2.25865 7.5113 2.25865 7.76723ZM2.25865 13.7672C2.25865 14.0289 2.16694 14.2514 1.98352 14.4348C1.80152 14.6168 1.58113 14.7078 1.32234 14.7078C1.06072 14.7078 0.838195 14.6168 0.654773 14.4348C0.471352 14.2514 0.379641 14.0289 0.379641 13.7672C0.379641 13.5042 0.472773 13.2824 0.659039 13.1018C0.845305 12.9198 1.06498 12.8288 1.31808 12.8288C1.57828 12.8288 1.80009 12.9212 1.98352 13.1061C2.16694 13.2909 2.25865 13.5113 2.25865 13.7672Z" fill="#141414"/>
                        </svg>
                      </el-button>
                    </el-popover>
                  </div>
                  </div>
                </div>
                <hr class="hr-table-batch">
                <div class="row-batch">
                  <div class="name d-flex">
                    <div class="title">ファイル名</div>
                    <div class="content-name ocr-text-truncate">
                      <router-link :to="{ name: 'confirm_result', params: { template_id: templateActive.id, template_batch_id: batch.id }}" class="ocr-template-name ocr-text-truncate decoration"><span>{{ batch.name }}</span></router-link>
                    </div>
                  </div>
                  <div class="is-reading d-flex">
                    <div class="title">読取完了</div>
                      <div class="content">
                        <div class="flex justify-between items-center table-status-column">
                        <el-progress
                            :stroke-width="8"
                            :show-text="false"
                            :percentage="calcProcessed(batch.n_files, batch.n_processed)"
                            class="ocr-progress-success ocr-progress column-progress"
                            :color="calcProcessed(batch.n_files, batch.n_processed) === 100 ? $store.state.user.setting.theme.rgb : '#7B7B7B'"
                        ></el-progress>
                        <div class="column-processed">
                          <el-button type="text" size="medium" class="p-0 text-center" v-if="calcProcessRunning(batch.status)">
                            <i class="el-icon-loading process-icon"></i>
                          </el-button>
                          <el-button type="text" size="medium" class="p-0 text-center" v-if="calcProcessFailed(batch.status)">
                            <i class="el-icon-circle-close process-icon red-icon"></i>
                          </el-button>
                          <el-button type="text" size="medium" class="p-0 text-center ocr-icon" v-else-if="calcProcessImage(batch.status) && calcProcessed(batch.n_files, batch.n_processed) === 100">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.99998 18C7.21995 18 5.47989 17.4722 3.99985 16.4832C2.51981 15.4943 1.36626 14.0887 0.685077 12.4442C0.00388972 10.7997 -0.174327 8.99004 0.17294 7.24421C0.520206 5.49838 1.37737 3.89474 2.63604 2.63606C3.89471 1.37739 5.49835 0.520192 7.24418 0.172925C8.99001 -0.174342 10.7996 0.00393278 12.4441 0.685122C14.0887 1.36631 15.4943 2.51983 16.4832 3.99987C17.4721 5.47992 18 7.22001 18 9.00004C17.9975 11.3862 17.0485 13.6739 15.3612 15.3612C13.6739 17.0485 11.3862 17.9975 8.99998 18V18ZM8.99998 1.51667C7.51991 1.51667 6.07307 1.95553 4.84244 2.77782C3.61181 3.6001 2.65266 4.76883 2.08626 6.13624C1.51987 7.50365 1.37168 9.00832 1.66043 10.46C1.94918 11.9116 2.66189 13.245 3.70846 14.2915C4.75503 15.3381 6.08844 16.0508 7.54007 16.3396C8.9917 16.6283 10.4963 16.4801 11.8637 15.9137C13.2311 15.3473 14.3999 14.3882 15.2222 13.1575C16.0444 11.9269 16.4834 10.4801 16.4834 9.00004C16.4811 7.01602 15.6919 5.11389 14.289 3.71098C12.8861 2.30806 10.984 1.51893 8.99998 1.51667V1.51667Z" fill="#FFCC33"/>
                              <path d="M7.79793 13.1184C7.67342 13.1184 7.55014 13.0938 7.43517 13.046C7.32019 12.9983 7.21578 12.9282 7.12797 12.84L3.81819 9.53015C3.65968 9.34868 3.57604 9.11382 3.58416 8.87301C3.59228 8.6322 3.69158 8.40347 3.86195 8.2331C4.03232 8.06272 4.26105 7.9634 4.50186 7.95528C4.74267 7.94715 4.97756 8.0308 5.15903 8.18931L7.79793 10.8292L12.6224 6.00468C12.8041 5.8477 13.0385 5.76529 13.2785 5.77407C13.5184 5.78286 13.7461 5.88216 13.9159 6.05201C14.0856 6.22186 14.1847 6.44964 14.1933 6.6896C14.2019 6.92956 14.1194 7.16388 13.9623 7.34546L8.46881 12.84C8.29087 13.018 8.0496 13.1181 7.79793 13.1184Z" fill="#FFCC33"/>
                            </svg>
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="checked d-flex">
                    <div class="title">チェック済</div>
                    <div class="content">
                      <div class="flex justify-between items-center table-status-column">
                        <div style="width: 95px;">{{ batch.n_confirmed }}/{{ batch.n_files }}</div>
                        <div class="column-processed">
                          <el-button type="text" size="medium" class="p-0 text-center ocr-icon" v-if="calcConfirmed(batch.n_confirmed, batch.n_results) >= 100">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.99998 18C7.21995 18 5.47989 17.4722 3.99985 16.4832C2.51981 15.4943 1.36626 14.0887 0.685077 12.4442C0.00388972 10.7997 -0.174327 8.99004 0.17294 7.24421C0.520206 5.49838 1.37737 3.89474 2.63604 2.63606C3.89471 1.37739 5.49835 0.520192 7.24418 0.172925C8.99001 -0.174342 10.7996 0.00393278 12.4441 0.685122C14.0887 1.36631 15.4943 2.51983 16.4832 3.99987C17.4721 5.47992 18 7.22001 18 9.00004C17.9975 11.3862 17.0485 13.6739 15.3612 15.3612C13.6739 17.0485 11.3862 17.9975 8.99998 18V18ZM8.99998 1.51667C7.51991 1.51667 6.07307 1.95553 4.84244 2.77782C3.61181 3.6001 2.65266 4.76883 2.08626 6.13624C1.51987 7.50365 1.37168 9.00832 1.66043 10.46C1.94918 11.9116 2.66189 13.245 3.70846 14.2915C4.75503 15.3381 6.08844 16.0508 7.54007 16.3396C8.9917 16.6283 10.4963 16.4801 11.8637 15.9137C13.2311 15.3473 14.3999 14.3882 15.2222 13.1575C16.0444 11.9269 16.4834 10.4801 16.4834 9.00004C16.4811 7.01602 15.6919 5.11389 14.289 3.71098C12.8861 2.30806 10.984 1.51893 8.99998 1.51667V1.51667Z" fill="#FFCC33"/>
                              <path d="M7.79793 13.1184C7.67342 13.1184 7.55014 13.0938 7.43517 13.046C7.32019 12.9983 7.21578 12.9282 7.12797 12.84L3.81819 9.53015C3.65968 9.34868 3.57604 9.11382 3.58416 8.87301C3.59228 8.6322 3.69158 8.40347 3.86195 8.2331C4.03232 8.06272 4.26105 7.9634 4.50186 7.95528C4.74267 7.94715 4.97756 8.0308 5.15903 8.18931L7.79793 10.8292L12.6224 6.00468C12.8041 5.8477 13.0385 5.76529 13.2785 5.77407C13.5184 5.78286 13.7461 5.88216 13.9159 6.05201C14.0856 6.22186 14.1847 6.44964 14.1933 6.6896C14.2019 6.92956 14.1194 7.16388 13.9623 7.34546L8.46881 12.84C8.29087 13.018 8.0496 13.1181 7.79793 13.1184Z" fill="#FFCC33"/>
                            </svg>
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-center py-4">
              データ無し
            </div>
          </div>
          <div
            :class="batchListFormat.length != 0 ? 'block' : 'hidden'"
            class="bg-white lg:absolute bottom-2 right-0 w-full"
          >
            <!-- PAGINATE -->
            <el-pagination
              class="text-center mt-4 ocr-pagination ocr-pagination-batch"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="paginate.currentPage"
              :page-sizes="getDevice == 'desktop' ? configPaginate.page_sizes : configPaginate.page_sizes_mobile"
              :page-size="configPaginate.page_size"
              :pager-count="getDevice == 'desktop' ? 7 : 5"
              layout="prev, pager, next, sizes"
              :total="paginate.totalItem"
            >
            </el-pagination>
          </div>
        </el-card>

      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="confirmDeleteBatch"
      :show-close="false"
      :width="getDevice == 'desktop' ? '30%' : '95%'"
      >
      <span>指定している読取バッチ一を本当に削除したいですか？</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="ocr-button ocr-button-default" @click="confirmDeleteBatch = false">いいえ</el-button>
        <el-button type="primary" class="btn-main ocr-button" @click="doDeleteBatch(batch)">はい、削除する</el-button>
      </span>
    </el-dialog>

    <el-drawer
      title="The title"
      :visible.sync="drawer.drawer"
      :direction="drawer.direction"
      :with-header="false"
      :before-close="handleClose">
      <ValidationObserver v-slot="{ invalid }">
      <div class="w-full h-full text-center flex justify-center pt-3">
        <div class="text-center w-1/2">
          <h3>テンプレートフォルダーの追加</h3>
          <div class="modal-content w-full">
            <ValidationProvider
              name="テンプレートフォルダー名"
              :rules="{
                required: true,
              }"
              v-slot="{ errors }"
              class=""
            >
              <div class="mt-4"><el-input placeholder="テンプレートフォルダー名" class="w-2/5" v-model="drawer.title"></el-input></div>
              <div class="mt-4"><span class="text-red-500">{{ errors[0] }}</span></div>
            </ValidationProvider>
            <div class="mt-3"><el-button @click="create" class="w-2/5" type="primary" :disabled="invalid">追加</el-button></div>
          </div>
        </div>
      </div>
    </ValidationObserver>
    </el-drawer>

    <el-dialog :visible.sync="showAddBatchModal" :close-on-click-modal="false" title=""
               :width="getDevice == 'desktop' ? '30%' : '95%'" custom-class="modal-add ocr-dialog" :show-close="false" @closed="resetFormAddBatch">
      <div v-if="showLoadingAddBatchModal" id="overlay">
        <i class="el-icon-loading"></i>
      </div>
      <span slot="title">
        <p class="flex">
          <span class="w-full el-dialog__title">バッチ名をつけてください</span>
          <span v-if="template.upload_files.length" class="w-full text-right upload-file-length">{{ template.upload_files.length }}枚</span>
        </p>
      </span>
      <ValidationObserver ref="formBatchPdf">
        <el-form ref="refBatchPdf"  @keyup.enter.prevent @submit.native.prevent="runTemplate" :model="template">
          <p class="mb-4 text-red-500">{{ errorCreateBatch }}</p>
          <p class="mb-4 text-red-500">{{ errorCreateBatchById }}</p>
          <el-checkbox class="ocr-checkbox mb-4" v-model="template.is_shooting" label="撮影の画像である"></el-checkbox>
          <el-checkbox class="ocr-checkbox ocr-checkbox-pdf mb-4" v-model="template.read_type" label="pdfファイルに対し1枚目だけ読取（デフォルトは全部のページを読取）"></el-checkbox>
          <ValidationProvider
              name="処理名"
              :rules="{
                required: true,
              }"
              v-slot="{ errors }"
              class=""
          >
            <el-input placeholder="現在の名" maxlength="100" v-model="template.name" class="mb-4 ocr-input"></el-input>
            <div v-if="showAddBatchModal"><span class="text-red-500">{{ errors[0] }}</span></div>
          </ValidationProvider>
        </el-form>
      </ValidationObserver>
      <template #footer>
          <span class="dialog-footer">
            <el-button  class="ocr-button ocr-button-default" @click="resetFormAddBatch">キャンセル</el-button>
            <el-button @click="runTemplate" class="btn-main ocr-button" :disabled="template.upload_files.length == 0 || !template.name">OK</el-button>
          </span>
      </template>
    </el-dialog>

    <el-dialog
      title="テンプレート名の変更"
      :visible.sync="showUpdateTemplateModal"
      :show-close="false"
      :width="getDevice === 'desktop' ? '30%' : '95%'"
      class="modal-add ocr-dialog"
      @closed="resetFormUpdateTemplate"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <ValidationObserver ref="formTemplateTargetEdit" >
        <el-form ref="templateTargetEdit" @keyup.enter.native="doSaveTemplateName">
          <p class="title-modal-add">現在の名</p>
            <el-input placeholder="テンプレート名" :disabled="true" v-model="templateTargetEdit.name" class="mb-4 ocr-input"></el-input>
          <p class="title-modal-add">新しい名</p>
          <ValidationProvider
              name="新しい名"
              :rules="{
                required: true,
              }"
              v-slot="{ errors }"
          >
            <el-input ref="templateNewName" placeholder="テンプレート名"  maxlength="100" v-model="templateTargetEdit.newName" class="mb-4 ocr-input"></el-input>
            <div v-if="showUpdateTemplateModal"><span class="text-red-500">{{ errors[0] }}</span></div>
          </ValidationProvider>
        </el-form>
      </ValidationObserver>
        <template #footer>
          <span class="dialog-footer">
            <el-button class="ocr-button ocr-button-default" @click="showUpdateTemplateModal = false">キャンセル</el-button>
            <el-button @click="doSaveTemplateName" class="btn-main ocr-button" :disabled="!templateTargetEdit.newName">更新</el-button>
          </span>
        </template>
    </el-dialog>

    <el-dialog
      title="読取バッチ名の変更"
      :visible.sync="showUpdateBatchModal"
      :show-close="false"
      direction="btt"
      :width="getDevice == 'desktop' ? '30%' : '95%'"
      class="modal-add ocr-dialog"
      @closed="resetFormUpdateBatch">
      <ValidationObserver ref="formBatchTargetEdit" >
        <el-form ref="batchTargetEdit"  @keyup.enter.native="doSaveBatchName">
          <p class="title-modal-add">現在の名</p>
          <el-input placeholder="読取バッチ一名" :disabled="true" v-model="batchTargetEdit.name" class="mb-4 ocr-input"></el-input>
          <p class="title-modal-add">新しい名</p>
          <ValidationProvider
              name="新しい名"
              :rules="{
                required: true,
              }"
              v-slot="{ errors }"
          >
            <el-input placeholder="読取バッチ一名" v-model="batchTargetEdit.newName" class="mb-4 ocr-input"></el-input>
            <div v-if="showUpdateBatchModal"><span class="text-red-500">{{ errors[0] }}</span></div>
          </ValidationProvider>
        </el-form>
      </ValidationObserver>
        <template #footer>
          <span class="dialog-footer">
            <el-button class="ocr-button ocr-button-default" @click="showUpdateBatchModal = false">キャンセル</el-button>
            <el-button @click="doSaveBatchName" class="btn-main ocr-button" :disabled="!batchTargetEdit.newName">更新</el-button>
          </span>
        </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import { head } from 'lodash';
import fixHeightMain from "@/mixins/fixHeightMain.mixin";
import _ from "lodash";
import { TEMPLATE_INVOICE_IDS, MULTIPLE_LINE_TITLES } from "@/constants/template";
import {groupItems, getTitleTemplate, groupItemsBatch} from '@/utils/template';
import { BUSINESS_CARD_ID, EXPORT_XLSX_ID } from '@/const/batch'
// import axios from '@/utils/axios';
import axios from 'axios';
import { configPaginate } from "@/config/paginate";
import Uploader from '@/components/Uploader';
export default {
  components: {
    Uploader
  },
  mixins: [fixHeightMain],
  data: function() {
    return {
      LAPTOP: 1024,
      invalid: true,
      errorCreateTemplate: '',
      errorCreateBatch: '',
      errorCreateBatchById: '',
      typingTimer: null,
      inputSearchTemplate: '',
      configPaginate,
      paginate: {
        currentPage: 1,
        totalPage: 1,
        totalItem: 1,
      },
      paginateTemplate: {
        currentPage: 1,
        totalPage: 1,
        totalItem: 1,
        page_size: 11
      },
      inputSearchBatch: '',
      is_active: null,
      batchListFormat: [],
      perPage: 15,
      page: 1,
      drawer: {
        drawer: false,
        direction: 'btt',
        title: "",
      },
      showAddBatchModal: false,
      showLoadingAddBatchModal: false,
      template: {
        upload_files: [],
        name: "",
        is_shooting: false,
        read_type: false
      },
      isTemplateMenuShow: null,
      showResultRunTemplate: false,
      process: 0,
      in_process: false,
      intervalId: "",
      batch: {},
      confirmDelete: false,
      confirmDeleteBatch: false,
      confirmDeleteCollection: false,
      resultBoxes: [],
      showUpdateBatchModal: false,
      showUpdateTemplateModal: false,
      templateTargetEdit: {},
      batchTargetEdit: {},
      batchListHeight: 0,
      currentBatchRow: false,
      resizeTimeoutId: null,
      showAddTemplateModal: false,
      defaultPercentage: 100,
      input: "",
      file_name: '',
      addNewTemplate: {
        id: "",
        name: "",
        collection_id: "",
        upload_file: "",
        is_preprocess: false,
        boxes: [
          {
            title: "",
            start_x: "",
            start_y: "",
            end_x: "",
            end_y: "",
            charset: "",
            n_lines: "",
          }
        ]
      },
      CSVNameDownload: null,
      selectedCSVDownloadId: null,
      activeBatchMobileId: null,
      errorMessages: null,
      disableCreate: false,
      backendUrl: process.env.VUE_APP_BACK_END_URL,
    }
  },
  computed: {
    ...mapState({
      collections: state => state.collection.collections,
      collectionActive: state => state.collection.collection,
      templateActive: state => state.template.template,
      batchList: state => state.template.batches,
      batchActive: state => state.template.batch
    }),
    ...mapGetters("device", ['getDevice', 'getDevicePixel']),
    ...mapGetters("auth", ["isCheckALlTemplate"]),
    ...mapState({
      items: state => state.template.items,
      query: state => state.template.querys
    }),
    items_data: function() {
      let data = [];
      /* For template has table */
      /* OUTPUT
        ----------------------------------------------
        |   ID   | 商品コード |   商品名   |    Date    |
        ----------------------------------------------
        |    1   |    720   |    P1     | 2021-01-02 |
        ----------------------------------------------
        |        |    721   |    P2     |            |
        ----------------------------------------------
        |        |    722   |    P2     |            |
        ----------------------------------------------
        |    2   |    800   |    P2     | 2021-11-16 |
        ----------------------------------------------
        |        |    801   |    P2     |            |
        ----------------------------------------------
       */
      // Type = 1, always has title
      if(this.items && !this.templateActive.is_assignment && (TEMPLATE_INVOICE_IDS.indexOf(this.templateActive.id) > -1)) {
        this.items.forEach(item => {
          let maxLines = item.images.reduce((prevMax, currObj) => {
            if (MULTIPLE_LINE_TITLES.indexOf(currObj.title) === -1 || !currObj.result) return prevMax;
            let currMax = currObj.result.split('\n').length;
            return Math.max(prevMax, currMax);
          }, 1);

          let line = null;
          for (let i = 0; i < maxLines; i++) {
            line = {
              // id: '',
              // image_path: '',
              // status: '',
            };

            if (i === 0) {
              line = {
                // id: item.id,
                // image_path: item.image_path,
                // status: item.status,
              };
            }

            item.images.forEach((box) => {
              line[box.title] = (i === 0) ? box.result : '';
              if (MULTIPLE_LINE_TITLES.indexOf(box.title) > -1 && box.result) {
                let results = box.result.split('\n');
                line[box.title] = typeof results[i] !== 'undefined' ? results[i] : '';
              }
            });
            data.push(line);
          }
        });
        return data;
      }
      // Type = 0, title in image = '', need get it from template boxes
      if(this.items && this.collectionActive.id === 1) {
        let items = groupItems(this.items);
        items.forEach(item => {
          let maxLines = 1;
          for (let i in item.group) {
            groupItemsBatch(item.group, i, this.templateActive.boxes)
            maxLines = Math.max(item.group[i].children.length, maxLines);
          }

          for (let i = 0; i < maxLines; i++) {
            let line = {
              画像名: '',
            };

            if (i === 0) {
              line = {
                画像名: this.getImageNameFromPath(item.image_path)
              };
            }
            // let order = 0;

            for (let j in item.group) {
              let box = item.group[j];
              let title = getTitleTemplate(box.parent, this.templateActive);
              if (!box.children.length) {
                if (i === 0) line[title] = box.parent.result;
                continue;
              }
              let boxChild = box.children[i] || {};
              line[title] = boxChild.result;
            }
            line = this.changeData(line)
            data.push(line);
          }
        });
        return data;
      }
      // Type = 0, title in image = '', need get it from template boxes
      if(this.items && !this.templateActive.is_assignment) {
         this.items.forEach((item, index) => {
          data.push({
            // id: "",
            // image_path: "",
            // status: "",
          })
          // data[index].id = item.id;
          // data[index].status = item.status;
          // data[index].image_path = item.image_path;
          item.images.forEach((box, boxIndex) => {
            if (!box.title) {
              box.title = this.resultBoxes?.boxes[boxIndex]?.title;
            }
            data[index][box.title] = (box.result)
          })
        })
      }
      if(this.items && this.templateActive.is_assignment) {
         this.items.forEach((item, index) => {
          data.push({
            // id: "",
            // image_path: "",
            // status: "",
            // result: "",
          })
          // data[index].id = item.id;
          // data[index].status = item.status;
          // data[index].image_path = item.image_path;
          if (this.items[index].score) {
            data[index].result = this.items[index].score;
          } else {
            data[index].result = `0/${this.items.length}`
          }
          item.images.forEach((box, boxIndex) => {
            if (!box.title) {
              box.title = this.resultBoxes?.boxes[boxIndex]?.title;
            }
            data[index][box.title] = (box.result)
          })
        })
      }
      return data;
    },
    templates: function(){
      let originTemplates = this.$store.state.template.templates;
      let orderTemplates = {};
      if (Array.isArray(originTemplates)) {
        orderTemplates.static = originTemplates.filter(function(item){
          return item.type == 1;
        });
        orderTemplates.dynamic = originTemplates.filter(function(item){
          return item.type == 0;
        });
      }
      return orderTemplates;
    },
    template_csv_export: function(){
      if (this.templateActive && this.templateActive.id === EXPORT_XLSX_ID) {
        return true
      }
      return false
    }
  },
  watch: {
    showResultRunTemplate () {
      this.calcBatchListHeight();
    },
    batchListFormat: {
      deep: true,
      handler () {
        this.triggerSelectBatch();
      }
    }
  },
  methods: {
    ...mapActions('collection', ['getCollections', 'createCollection', 'setCollection']),
    ...mapActions('template', ['createTemplate', 'getTemplate', 'getResult', 'getTemplates', 'deleteTemplate', 'getTemplateResult', 'deleteCollection', 'saveTemplateName', 'getBatchList', 'getBatch', 'saveBatchName', 'deleteBatch', 'getBatchResultCsv', 'searchBatchName', 'searchTemplateName', 'reRunTemplateBatch']),
    ...mapActions(['loading']),
    ...mapMutations('template', ['SET_TEMPLATE', 'SET_BATCHES', 'SET_BATCH']),
    closeModalAddTemplate() {
      this.$refs.processTemplate.reset()
      this.$refs.nameTemplate.reset()
      this.errorCreateTemplate = null
      this.showAddTemplateModal = false
    },
   changeData (data = {}) {
      const obj = {"0_画像名": " " + data["画像名"]};
       const entries = Object.keys(data)
       entries.forEach((value) => {
           if (value !== "画像名") {
               obj[value] = " " + data[value] ? data[value] : "";
           }
       })
      return obj;
    },
    calcProcessImage(status) {
      return status === 1
    },
    calcProcessFailed(status) {
      return status === 2
    },

    calcProcessRunning(status) {
      return status === 0
    },
    selectFileTemplate: function() {
      this.$refs.selectFileTemplate.click();
    },

    down_csv(row, mobile = true) {
      this.CSVNameDownload = row.name
      this.selectedCSVDownloadId = row.id;
      if (mobile) {
        this.handleChangeBatch(row, true);
      }
    },

    showPopOver(id) {
      this.is_active = id;
    },
    hidePopOver() {
      this.is_active = null;
    },

    openUpdateTemplateModal: function(template) {
      this.templateTargetEdit = _.cloneDeep(template);
      this.showUpdateTemplateModal = true;
    },
    showTemplateMenu (id) {
      this.isTemplateMenuShow = id;
    },
    async selectBatch (batch) {
      this.getBatch(batch);
    },
    batchDetail() {
      this.$router.push({
        path: `/confirm_result/${this.batch.template_id}/batch/${this.batch.template_batch_id}`,
      })
    },
    openModalAddBatch: function () {
      this.showAddBatchModal = true;
    },
    openUpdateBatchModal: function(batch) {
      this.batchTargetEdit = _.cloneDeep(batch);
      this.showUpdateBatchModal = true;
    },
    handleChangeBatch: async function(batchSelected, key = false) {
      if (!batchSelected) {
        return false;
      }

      this.showResultRunTemplate = true;
      this.batch.name = batchSelected.name;
      this.batch.template_batch_id = batchSelected.id;
      this.batch.template_id = this.templateActive.id;
      this.currentBatchRow = batchSelected;

      await this.getTemplateStatus(this.batch);
      let rs = await this.getTemplateResult({
        template_batch_id: batchSelected.id,
        template_id: this.templateActive.id
      });
      this.$store.commit("template/SET_ITEMS", rs.items);
      var self = this;
      if(this.templateActive.is_assignment) {
        this.items.map(item => {
          // 1. reset item's result
          let correctCount = 0;
          // 2. Tinh so ket qua chinh xac
          item.images.forEach(function(box_result, box_index) {
            if(box_result.result === self.resultBoxes.boxes[box_index]?.ground_truth) {
              correctCount++;
            }
          });
          // 3. Set result rate
          item.score = `${correctCount}/${this.resultBoxes.boxes.length}`;
        })
      }
      if (this.selectedCSVDownloadId && key) {
        this.downloadCSV(batchSelected.id);
      }
    },

    // Download CSV
    downloadCSV(batchId) {
      let curentRow = `download_csv_detail_${batchId}`;
      setTimeout(() => {
        if (this.getDevice === 'desktop') {
          this.$refs[curentRow].$el.click();
        } else {
          this.$refs[curentRow][0].$el.click();
        }
        this.selectedCSVDownloadId = null;
      }, 200)
    },

    fetchBatchList: async function(showLoading = true) {
      if (!this.templateActive?.id) return false;
      if(showLoading) {
        this.loading(true);
      }
      const data = {
        id: this.templateActive.id,
        page: this.paginate.currentPage,
        page_size: this.configPaginate.page_size,
      }
      let batch =  await this.getBatchList(data);
      if (batch) {
        this.paginate.currentPage = batch.current_page;
        this.paginate.totalPage = batch.num_pages;
        this.paginate.totalItem = batch.count;
        this.configPaginate.page_size = batch.page_size;
        if (batch.results) {
          this.batchListFormat = _.cloneDeep(batch.results);
        }
      }
      if (batch.results.length) {
        const hasProcessing = batch.results.every(item => item.n_results === item.n_processed);
        if (hasProcessing) {
          clearInterval(this.intervalId);
        }
      }
      this.loading(false);
      return batch;
    },
    fetchCollections: async function() {
      await this.getCollections({});
    },
    selectCollection: async function(collection) {
      await this.setCollection(collection);
      const data = {
        id: this.collectionActive.id,
        page: this.paginateTemplate.currentPage,
        page_size: this.paginateTemplate.page_size,
      }
      await this.getTemplates(data);
      // Reset selected template
      this.SET_TEMPLATE({});
      this.SET_BATCHES([]);
    },
    selectTemplate: async function(template) {
      this.templateActive.id = template.id;
      const batch = await this.fetchBatchList(false);
      if (batch.results.length) {
        const hasProcessing = batch.results.some(item => item.n_results !== item.n_processed);
        if (hasProcessing) {
          this.intervalId = this.setFetchPageInterval();
        }
      }
      await this.fetchTemplate(template.id);
    },
    calcProcessed: function (n_files, n_processed) {
      let processed = 0;
      if (n_files != 0) {
        processed = parseFloat(((n_processed / n_files) * 100).toFixed(2));
        if (processed > 100) {
          processed = 100;
        }
      }
      return processed;
    },
    calcConfirmed: function (n_confirmed, n_results) {
        let confirmed = 0;
        if (n_results != 0) {
          confirmed = parseFloat(((n_confirmed / n_results) * 100).toFixed(2));
          if (confirmed > 100) {
            return confirmed = 100;
          } else return confirmed;
        } else return confirmed = 0;
    },
    openOptioncollection: function() {
      // to do
    },
    openOptionTemplate: function() {
      // to do
    },
    openOptionBatch: function(data) {
      // todo
      this.is_active = data.id;
    },
    openModalAddTemplate: function() {
      this.showAddTemplateModal = true;
      // this.$router.push({
      //   name: 'master_template',
      //   query: {
      //     collectionActiveId: this.collectionActive.id,
      //   }
      // })
    },
    handleClose: function(done) {
       this.$confirm(`テンプレートフォルダーの追加をキャンセルしますか？`,
        {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
        })
        .then(() => {
          this.drawer.title = "";
          done();
        })
        .catch(() => {});
    },
    handleCloseUpdateTemplateModal: function(done) {
       this.$confirm(`テンプレート名編集をキャンセルしますか？`,
        {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
        })
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    create: async function() {
      let res = await this.createCollection(JSON.stringify({title: this.drawer.title,}))
      if(res) {
        this.getCollections({});
        this.closeDrawer();
      }

    },
    createNewTemplate: async function() {
      const isValid = await this.$refs.formAddTemplate.validate()
      if (!isValid || !this.addNewTemplate.name || !this.file_name) {
        return;
      }
      this.disableCreate = true
      var formData = new FormData()
      for( var key in this.addNewTemplate ) {
        formData.append(key, this.addNewTemplate[key]);
      }
      let response = await this.createTemplate(formData);
      if(response.success) {
        this.showAddTemplateModal = false;
        this.addNewTemplate = {};
        this.file_name = "";
        this.$router.push({
          name: 'template.edit',
          params: {
            id: response.data.id,
          }
        })
      } else {
        this.showAddTemplateModal = true;
        this.errorCreateTemplate = response.data.message ? response.data.message  : response.data;
      }
      this.disableCreate = false
    },
    chooseFileTemplate: function(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.addNewTemplate.upload_file = files[0];
      this.file_name = this.addNewTemplate.upload_file.name;
      this.errorCreateTemplate = '';
    },
    gotoListTemplate: function() {
      this.$router.push({
        name: 'templates',
      })
    },
    closeDrawer() {
      this.drawer.drawer = false;
      this.drawer.title = "";
    },
    goToTemplateDetail: function(id, collectionActiveId) {
      this.$router.push(
        {
          name: 'template.edit',
          params: { id: id, collectionId: collectionActiveId }
        }
      )
    },
    goToTemplateAssignment: function(id) {
      this.$router.push(
        {
          name: 'template.assignment',
          params: {
            id: id,
          }
        }
      )
    },
    doDeleteBatch: async function(batchSelected) {
      let res = await this.deleteBatch({
        template_batch_id: batchSelected.template_batch_id,
        template_id: batchSelected.template_id,
      });
      if(res) {
        await this.selectTemplate(this.templateActive);
      }
      this.confirmDeleteBatch = false;
    },
    doDeleteTemplate: async function() {
      let res = await this.deleteTemplate(this.templateActive.id);
      if(res) {
        this.templateActive.id = ""
        this.batchListFormat = false;
        const data = {
          id: this.collectionActive.id,
          page: this.paginateTemplate.currentPage,
          page_size: this.paginateTemplate.page_size
        }
        this.getTemplates(data);
        this.SET_BATCHES([]);
      }
      this.confirmDelete = false;
    },
    doDeleteCollection: async function() {
      let res = await this.deleteCollection(this.collectionActive.id);
      if(res) {
        this.fetchCollections();
      }
      this.confirmDeleteCollection = false;
    },
    selectFile: function() {
      this.$refs.selectFile.click();
    },
    chooseFile: function(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      const arr = [...files];
      arr.forEach(file => {
        this.template.upload_files.push(file);
      })
    },
    runTemplate: async function() {
      const isValid = await this.$refs.formBatchPdf.validate()
      if (!isValid) {
        return;
      }
      this.errorCreateBatchById = "";
      if(!this.templateActive.id) {
        this.errorCreateBatchById = 'バッチを作成するのはまずテンプレートを選んでください。'
        return;
      }
      this.showLoadingAddBatchModal = true;
      var sefl = this;
      const readType = sefl.template.read_type ? 1 : 0;
      let formData = new FormData();
      formData.append("name", sefl.template.name);
      formData.append('is_scan', !sefl.template.is_shooting);
      formData.append('read_type', readType);
      sefl.template.upload_files.forEach(file => {
        formData.append("upload_files", file);
      })
      try {
        let response = await sefl.$store.dispatch("ocr/runTemplate", {
          formData: formData,
          id: sefl.templateActive.id,
        });
        if (response.success === true) {
          sefl.batch = response.data;
          await this.selectTemplate(this.templateActive);
          this.showAddBatchModal = false;
          sefl.template.upload_files = [];
          sefl.template.name = '';
          sefl.getTemplateStatus(sefl.batch);
        } else {
          this.showAddBatchModal = true;
          this.errorCreateBatch = response.data.message ? response.data.message : response.data;
        }
        this.$refs.refBatchPdf.clearValidate();
        this.$refs.refBatchPdf.resetFields()
        this.showLoadingAddBatchModal = false;
      } catch (error) {
        this.showAddBatchModal = false;
        this.$refs.refBatchPdf.clearValidate();
        this.$refs.refBatchPdf.resetFields()
        this.showLoadingAddBatchModal = false;
        localStorage.setItem('showNotify', 'true');
        window.location.reload();
      }
    },
    getTemplateStatus: async function(batch) {
      var sefl = this;
      let response = await sefl.$store.dispatch("ocr/getTemplateStatus", {
        batch_id: batch.template_batch_id,
        id: batch.template_id,
      });
      sefl.process = (response.n_processed/response.n_files) * 100;
      return response;
    },
    confirmResult: function() {
      this.$router.push({
        path: `/confirm_result/${this.batch.template_id}/batch/${this.batch.template_batch_id}`,
      })
    },
    gotoInstant: function(){
        this.$router.push({
          name: 'test-ocr',
          params: {
            id: 0,
          }
        })
    },
    fetchTemplate: async function(id) {
      let res = await this.getResult(id);
      if (res  !== "ライセンスの有効期限が切れています!") {
          this.SET_BATCH(null);
          this.template.resultBoxes = res;
          this.resultBoxes = res;
      }
    },
    doSaveBatchName: async function() {
      const isValid = await this.$refs.formBatchTargetEdit.validate();
      if (!isValid) {
        return;
      }
      this.loading(true);
      let formData = new FormData();
      formData.append("name", this.batchTargetEdit.newName);
      formData.append("template_id", this.templateActive.id);
      formData.append("id", this.batchTargetEdit.id);
      await this.saveBatchName(formData);
      await this.selectTemplate(this.templateActive);
      // await this.getBatchList(this.templateActive.id);
      this.showUpdateBatchModal = false;
      this.batchTargetEdit = {};
      this.loading(false);
    },
    doSaveTemplateName: async function() {
      const isValid = await this.$refs.formTemplateTargetEdit.validate();
      if (!isValid) {
        return;
      }
      this.loading(true);
      var formData = new FormData()
      formData.append("name", this.templateTargetEdit.newName);
      formData.append("id", this.templateTargetEdit.id);
      await this.saveTemplateName(formData);
      const data = {
        id: this.collectionActive.id,
        page: this.paginateTemplate.currentPage,
        page_size: this.paginateTemplate.page_size
      }
      await this.getTemplates(data);
      this.showUpdateTemplateModal = false;
      this.templateTargetEdit = {};
      this.loading(false);
    },
    downloadCsvFromBatch: async function(){
      // alert("download");
      if (this.batchActive.status == 0){
        console.log('Index.vue - 809 Not finish', );
        return;
      }
      // console.log('Index.vue - 806', this.batch);
      const csv_items = await this.getBatchResultCsv(this.batch);
      console.log('Index.vue - 809', csv_items);
      // const links = [
      //   "http://10.117.0.63/storage/template_batch/20211204113811_%E3%81%9D%E3%81%AE%E5%A0%B4%E3%81%A7%E8%AA%AD%E3%82%80%E3%83%87%E3%83%A2%E7%94%A8%E7%B4%99%E3%83%87%E3%83%BC%E3%82%BF_%E8%AB%8B%E6%B1%82%E6%9B%B801_nRD1w7n_0.xlsx"
      // ]
      csv_items.forEach(item => {
        axios.get(item, {
            // headers: {
            //   'Access-Control-Allow-Origin': '*',
            //   'Access-Control-Allow-Credentials':true,
            //   "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
            //   "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
            // },
            // crossDomain: true,
            responseType: 'blob'
        }).then((response) => {
            console.log('Index.vue - 814', item,response);
            // if (!response) {
            //   alert("Cannot get file.")
            //   return;
            // }
            const url = URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
            }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', item.split(/(\\|\/)/g).pop())
            document.body.appendChild(link)
            link.click()
        });
      })

    },
    onWindowResize () {
      // Clear exist timeout
      clearTimeout(this.resizeTimeoutId);
      // Set timeout function, only handle the last size. Run resize slider after 500ms
      this.resizeTimeoutId = setTimeout(() => {
        this.setContainerHeight();
        this.calcBatchListHeight();
      }, 500);
    },
    calcBatchListHeight () {
      // Wait a moment to get updated dom
      setTimeout(() => {
        const cardSelector =  this.$refs['batch-list-ref'];
        if (typeof cardSelector === 'undefined') {
          return 0;
        }
        const cardHeight = cardSelector?.offsetHeight;
        const headerHeight = cardSelector.querySelector('.el-card__header')?.offsetHeight;
        let batchProgressHeight = 0;
        const batchProgressSelector = cardSelector.querySelector('.show-result-run-template');
        if (batchProgressSelector) batchProgressHeight = batchProgressSelector.offsetHeight;
        this.batchListHeight = cardHeight - headerHeight - batchProgressHeight;
      }, 100);
    },
    fetchData: async function () {
      const data = {
        id: this.collectionActive.id,
        page: this.paginateTemplate.currentPage,
        page_size: this.isCheckALlTemplate ? this.paginateTemplate.page_size : 12,
      }
      let res = await this.getTemplates(data);
      this.paginateTemplate.currentPage = res.current_page;
      this.paginateTemplate.totalPage = res.num_pages;
      this.paginateTemplate.totalItem = res.count;
    },
    reRunOCR: async function (row) {
      this.loading(true);
      event.target.parentElement.parentElement.style.display = "none";
      const data = {
        id: this.templateActive.id,
        batchId: row.id,
      }
      let res = await this.reRunTemplateBatch(data);
      if (res) {
        this.intervalId = this.setFetchPageInterval();
      }
      this.loading(false);
    },
    keyUpSearchTemplate() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        this.searchTemplate();
      }, 500);
    },
    keyUpSearchBatch() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        this.searchBatch();
      }, 500);
    },
    searchTemplate: async function () {
      const data = {
        collection_id: this.collectionActive.id,
        name_search: this.inputSearchTemplate,
        page: this.paginateTemplate.currentPage,
        page_size: this.isCheckALlTemplate ? this.paginateTemplate.page_size : 12,
      }
      let res = await this.searchTemplateName(data);
      this.paginateTemplate.currentPage = res.current_page;
      this.paginateTemplate.totalPage = res.num_pages;
      this.paginateTemplate.totalItem = res.count;
      clearInterval(this.intervalId);
    },

    searchBatch: async function () {
      const data = {
        template_id: this.templateActive.id,
        name_search: this.inputSearchBatch,
        page: this.paginate.currentPage,
        page_size: this.configPaginate.page_size,
      }
      let res = await this.searchBatchName(data);
      this.paginate.currentPage = res.current_page;
      this.paginate.totalPage = res.num_pages;
      this.paginate.totalItem = res.count;
      this.configPaginate.page_size = res.page_size;
      this.batchListFormat = _.cloneDeep(res.results);
      clearInterval(this.intervalId);
    },
    handleCurrentChange: async function (val) {
      this.paginate.currentPage = val;
      if (this.inputSearchBatch) {
        this.searchBatch()
      } else {
        this.fetchBatchList();
      }
    },
    handleSizeChange(val) {
      this.configPaginate.page_size = val;
      if (this.inputSearchBatch) {
        this.searchBatch()
      } else {
        this.fetchBatchList();
      }
    },
    handleCurrentChangeTemplate: async function (val) {
      this.paginateTemplate.currentPage = val;
      if (this.inputSearchTemplate) {
        this.searchTemplate()
      } else {
        this.fetchData();
      }
    },
    resetFormAddTemplate: function() {
      this.showAddTemplateModal = false;
      this.addNewTemplate.id = "";
      this.addNewTemplate.name = "";
      this.addNewTemplate.collection_id = 1;
      this.addNewTemplate.upload_file = "";
      this.addNewTemplate.boxes = [
        {
          title: "",
          start_x: "",
          start_y: "",
          end_x: "",
          end_y: "",
          charset: "",
          n_lines: "",
        }
      ];

      this.file_name = '';
      this.errorCreateTemplate = '';
      this.$refs.refAddTemplate.resetFields();
      this.$refs.refAddTemplate.clearValidate();
      this.$refs.formAddTemplate.reset();
    },
    resetFormUpdateTemplate:async function() {
      this.$refs.templateTargetEdit.resetFields();
      this.$refs.formTemplateTargetEdit.reset();
      this.templateTargetEdit = {};
    },
    resetFormUpdateBatch: function() {
      this.$refs.batchTargetEdit.resetFields();
      this.$refs.formBatchTargetEdit.reset();
      this.batchTargetEdit = {};
    },
    resetFormAddBatch: function() {
      this.$refs.refBatchPdf.clearValidate();
      this.$refs.refBatchPdf.resetFields()
      this.errorCreateBatchById = ''
      this.template = {
        upload_files: [],
        name: "",
        is_shooting: false,
        read_type: false
      }
      this.errorCreateBatch = '';
      this.$refs['ocr-uploader'].reset();
      this.showAddBatchModal = false
    },
    getImageNameFromPath (path = '') {
      // let indexLast = path.lastIndexOf("/");
      // let name = path.substr(indexLast + 1);
      // let nameArray = name.split('_');
      // let extension = nameArray[nameArray.length - 1];
      // nameArray.splice(nameArray.length - 2, 2);
      // name = nameArray.join('_') + extension;
      // return name;
      let indexLast = path.lastIndexOf("/");
      return path.substr(indexLast + 1);
    },

    // set time auto fetch template list, fetch batch list
    setFetchPageInterval(second = 10000) {
      clearInterval(this.intervalId);
      this.fetchPageInterval();
      return setInterval(() => {
        this.fetchPageInterval();
      }, second);
    },
    fetchPageInterval() {
      if (this.inputSearchTemplate) {
        this.searchTemplate()
      } else {
        if (this.templateActive.id) {
          // Fetch template & batch list
          this.fetchBatchList(false);
          this.fetchTemplate(this.templateActive.id);
          return;
        } else {
          this.fetchData();
        }
      }
      if (this.inputSearchBatch) {
        this.searchBatch()
      }
      else {
        this.fetchBatchList(false);
        return;
      }
    },
    triggerSelectBatch () {
      if (this.batchActive && this.getDevice == "desktop") {
        this.batchRow = _.find(this.batchListFormat, item => {
          return item.id == this.batchActive.id
        });
        if (this.batchRow) {
          this.$refs['batch-list-table'].setCurrentRow(this.batchRow);
        }

      }
    },

    chooseFileBatchUpload: function(file) {
      this.openModalAddBatch();
      this.template.upload_files.push(file);
    },
    onFilesAdded (files) {
      if (!files[0]) return false;
      let name = files[0].name;
      if (name.length > 100) {
          name = name.slice(0,100);
      }
      // Is file
      if (files[0].type && !this.template.name) {
        return this.template.name = name.replace(/\.[^.]*$/,'');
      }
      // Is folder
      return this.template.name = name;
    },

    // Active Batch When Click Mobile
    activeBatchMobile(batch) {
      this.batch.name = batch.name;
      this.batch.template_batch_id = batch.id;
      this.batch.template_id = this.templateActive.id;
      this.activeBatchMobileId = batch.id;
    },
    changeLabelCSV () {
      let label = {};
      label['0_画像名'] = '画像名';
      const arrayKey = [];
      for (let obj of this.items_data) {
        let keyObj = Object.keys(obj);
        keyObj.forEach(item => {
          if (!arrayKey.includes(item)) {
            arrayKey.push(item)
          }
        })
      }
      arrayKey.forEach(item => {
        if (item !== '0_画像名') {
          let index = item.indexOf("_")
          label[item] = item.slice(index + 1).trim()
        }
      })
      return label;
    },
    checkFinish() {
      this.arrayToCsv(this.items_data)
    },
    arrayToCsv(data) {
      const label = this.changeLabelCSV();
      const array = [Object.values(label)];
      const arrayPush = [];
      data.forEach(item => {
        let obj = []
        Object.keys(label).forEach(itemKey => {
          obj[itemKey] = item[itemKey] ? item[itemKey] : '';
        })
        arrayPush.push(obj)
      });
      const dataExport = array.concat(arrayPush);
      let arrayExport = dataExport.map(it => {
        return Object.values(it)
      });
      arrayExport = this.$papa.unparse(arrayExport, {
        delimiter: ","
      });
      this.downloadBlob(arrayExport)
      return dataExport;
    },

    downloadBlob(content) {
      const blob = new Blob(["\ufeff" + content], { type: 'text/csv;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const pom = document.createElement('a');
      pom.href = url;
      pom.setAttribute('download', this.CSVNameDownload + ".csv");
      pom.click();
    },
  },
  created: async function() {
    if (this.getDevicePixel <= this.LAPTOP) {
      this.paginateTemplate.page_size = 5;
      this.configPaginate.page_size = 4;
    }
    if (this.$store.state.template.template.id && (this.$store.state.template.template.id === BUSINESS_CARD_ID || this.$store.state.template.template.id === EXPORT_XLSX_ID)){
      const dataTemplate = {
        boxes: [],
        collection_id:1,
        ground_truth_image:null,
        id:0,
        is_assignment:false,
        is_instant:false,
        is_preprocess:false,
        name:"",
        type:0,
        url: ''
      }
      this.$store.commit('template/SET_TEMPLATE', {...dataTemplate})
    }
    // Get collection list
    await this.fetchCollections();
    // Fetch collection
    let selectedCollection = this.collectionActive?.id ? this.collectionActive : head(this.collections);
    if (!selectedCollection) return;
    await this.setCollection(selectedCollection);

    // Fetch template list
    const data = {
      id: selectedCollection.id,
      page: this.paginateTemplate.currentPage,
      page_size: this.isCheckALlTemplate ? this.paginateTemplate.page_size : 12
    }
    let res =  await this.getTemplates(data);
    this.paginateTemplate.currentPage = res.current_page;
    this.paginateTemplate.totalPage = res.num_pages;
    this.paginateTemplate.totalItem = res.count;

    this.intervalId = this.setFetchPageInterval();

    let params = this.$route.params;
    if(params.show_result) {
      this.showResultRunTemplate = params.show_result;
      this.process = params.n_process;
    }
    if(this.query) {
      this.batch.template_batch_id = this.query.template_batch_id;
      this.batch.template_id = this.query.template_id;
    }

    let collectionActiveId = 1;
    if(collectionActiveId) {
      this.addNewTemplate.collection_id = collectionActiveId;
    }
  },
  mounted () {
    if (localStorage.getItem('showNotify') === 'true') {
      this.$notify.success({
        message: 'ファイルサイズが大きすぎますが、処理を続行しています。',
      });
      localStorage.removeItem('showNotify');
    }
    this.calcBatchListHeight();
    window.addEventListener("resize", this.onWindowResize);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
    window.removeEventListener("resize", this.onWindowResize);
  }
};
</script>

<style lang="scss" scoped>
.batch-list/deep/.el-card__body {
  overflow: scroll;
}
.text {
  font-size: 14px;
}

.fz-24 {
  font-size: 24px;
}

.item {
  margin-bottom: 18px;
}

.collection-list {
  width: 32%;
}

/deep/.modal-add-batch {
  position: relative;
}
/deep/.modal-add .el-dialog__header {
  border-bottom: 1px solid #F0F0F0;
}

/deep/.modal-add .el-dialog__footer {
  border-top: 1px solid #F0F0F0;
}

.title-modal-add {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #000000;
  margin-bottom: 8px;
}

.template-search-input /deep/ .el-input__inner {
  border: none;
  border-bottom: 1px solid #DCDFE6;
  border-radius: unset;
}

.template-search-input /deep/ .el-input-group__append {
  background: none;
  border: none;
  border-bottom: 1px solid #DCDFE6;
  border-radius: unset;
  padding: 0 10px;
}

.custom-input-search {
  max-width: 50%;
}

.custom-btn-add {
  background: #FDB92C;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: #0F172A;
  padding: 5px 16px;
  font-weight: 400;
  display: flex;
  align-items: center;
  height: 24px;
}

.template-list {
  width: 100%;
  height: calc(100% - 20px);
  margin-right: 16px;
  position: relative;
  background: #FFFFFF;
  padding: 16px;
  padding-bottom: 0;
}

.template-list/deep/.el-card__header, .batch-list/deep/.el-card__header {
  background: #fff;
  width: 100%;
  padding: 0 !important;
  border: unset;
}

.template-list/deep/.el-card, .batch-list/deep/.el-card {
  border-radius: unset;
}

.batch-list {
  width: 100%;
  height: calc(100% - 20px);
  margin-left: 16px;
  background: #FFFFFF;
  padding: 16px;
  padding-bottom: 0;
}

.batch-list/deep/.el-card__body, .template-list/deep/.el-card__body {
  overflow-x: hidden;
  overflow-y: auto;
}
.template-list/deep/.el-card__body {
  height: calc(100% - 61px);
}

.batch-list/deep/.el-card__body {
  height: calc(100% - 370px) !important;
}

.progress-confirm {
  margin-left: -14px !important;
}

.cover-template {
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  max-height: calc(100% - 70px);
}

.template-list /deep/ .el-card__body {
  overflow: auto;
  padding-bottom: 20px;
}

.template-grid-item {
  width: calc(25% - 20px);
  margin: 10px;
}

.template-grid-item-grid {
  position: relative;
  width: 100%;
  padding-top: 100%;
  border: 1px solid #E8E8E8;
  background: #F4F4F4;
}

.template-grid-item-content {
  position: absolute;
  top:      0;
  left:     0;
  bottom:   0;
  right:    0;
  padding: 10px;
}

.template-grid-item-menu {
  position: absolute;
  right: -5px;
  top: -5px;
}

.template-grid-item-menu .el-icon-setting {
  font-weight: normal;
  z-index: 1;
  border: 1px solid #E8E8E8;
}

.template-grid-item-content img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
}

.add-template-button {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
}
.orc-status-column {
  width: 45%;
}

.template-grid-item-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgba(209, 213, 219, var(--tw-bg-opacity))!important;
}
.batch-progress-container {
  min-width: 50%;
}
/deep/.custom-name-tbl-batch > .cell > .ocr-template-name {
  font-size: 18px;
  line-height: 21px;
}
.btn-rename-batch {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.05em;
  color: #0F172A;
  text-align: left;
  margin: unset;
  padding: 10px 20px;
}

.btn-rename-batch:active, .btn-rename-batch:hover {
  color: #C85C54;
  background: #E0E5ED;
}

.status-batch {
  width: 25%;
  font-weight: 300 !important;
  font-size: 14px;
  line-height: 21px;
  color: #0F172A;
  display: inline-block;
  text-align: left;
}

.custom-name-batch {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #0F172A;
}
.bg-fa {
  background: #fafafa;
}

.custom-icon-close {
  padding: 6px;
  background: #FFFFFF;
  border-radius: 50%;
  font-weight: bold;
  z-index: 2002;
  position: relative;
  border: 1px solid #F0F0F0;
}

.custom-el-icon-more {
  font-size: 24px;
  transform: rotate(90deg);
}

.custom-el-table {
  cursor: pointer;
}

.el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: rgba(253, 244, 224, 0.45);
}

/deep/.custom-name-tbl-batch {
  padding-left: 10px;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #0F172A;
}

.custom-popover {
  position: absolute;
  top: 0px;
  right: 5px;
  background: #F4F4F4;
  border-radius: unset !important;
  z-index: 10000;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
  border: 0.5px solid #7B7B7B;
  padding: 10px 0;
}

.bg-yellow:hover {
  background: rgba(253, 244, 224, 0.45);
}
.bg-yellow-active {
  background: #FDF4E0;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

/deep/.el-card__body {
  padding: 0;
}
/deep/.el-card.is-always-shadow {
  box-shadow: 0 0 0 0;
}
.window-close {
  position: absolute;
  top: 10px;
  right: 10px;
}
.width-btn {
  width: 130px;
}
#overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(93, 93, 93, 0.5);
  z-index: 200000;
  cursor: pointer;
}
.content-name {
  width: calc(100% - 102px);
}
#overlay .el-icon-loading {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 300%;
}

.table-status-column /deep/ .column-progress {
  margin-right: 23px;
}

.table-status-column /deep/ .column-processed {
  display: flex;
  align-items: center;
  margin-right: 25px;
}
/deep/ .el-pagination__sizes {
  position: absolute;
  right: 0;
  margin: 0;
}
.decoration:hover {
  text-decoration: underline solid #0F172A !important;
}
.upload-file-length {
  font-size: 12px;
  line-height: 17px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.batch-title {
  font-weight: bold;
}

.ocr-checkbox-pdf {
  display: flex;
  align-items: flex-start;
}
.ocr-checkbox-pdf /deep/ .el-checkbox__label {
  white-space: break-spaces;
}
/deep/.red-icon {
  color: red;
}

@media only screen and (max-width: 480px) {
  .custom-btn-add {
    padding: 0 12px;
  }
  .batch-list {
    display: block;
  }
  .search-batch-list {
    width: 100%;
  }
}
@media only screen and (max-width: 821px) {
  .batch-list/deep/.el-card__body, .template-list/deep/.el-card__body {
    height: auto;
  }
  .template-list {
    padding: 0;
    margin: 0;
  }
  .batch-list {
    padding: 0;
  }
  .batch-list/deep/.el-card__body {
    height: auto !important;
    padding-bottom: 20px;
  }
  .ocr-progress {
    width: 72px;
  }
  ::v-deep .el-icon-plus {
    font-size: 20px;
  }
  .template-grid-item-content {
    padding: 7px 8px;
  }
  .custom-icon-close {
    padding: 5px;
  }
  .template-grid-item-menu {
    top: 0;
    right: 0;
  }
  .template-grid-item-menu .el-icon-setting {
    border: none;
    background: none;
  }
  ::v-deep .el-icon-more {
    line-height: 24px;
  }
  .list-title {
    font-weight: bold;
    font-size: 14px;
  }
  .ocr-pagination-batch {
    padding-bottom: 12px;
  }
  .popover-block {
    width: 20px;
  }
  .custom-popover-list {
    right: 0 !important;
  }
}
@media only screen and (max-width: 1023px) {
  ::v-deep .el-pagination__sizes {
    display: none !important;
  }
  .template-grid-item {
    margin: 5px;
    width: calc(100% / 3 - 10px);
  }
  ::v-deep .ocr-button {
    line-height: 12px;
  }
}
@media only screen and (max-width: 1024px) {
  .batch-list {
    margin-left: 0 !important;
  }
  ::v-deep .el-pager .more::before {
   line-height: normal;
  }
  ::v-deep .el-pager li.btn-quicknext, .el-pager li.btn-quickprev {
    line-height: 24px;
  }
  ::v-deep .el-pager .number {
    font-weight: 400 !important;
  }
  .template-grid-item-grid {
    border: 1px solid #7b7b7b;
  }
}

@media only screen and (min-width: 821px) and (max-width: 1023px)  {
  .batch-list/deep/.el-card__body, .template-list/deep/.el-card__body {
    height: auto;
  }
  .cover-template {
    height: 100%;
  }
  .batch-list {
    height: 100%;
  }
  .batch-list/deep/.el-card__body {
    height: 100% !important;
  }
}
</style>
